import React from 'react';
import { useParams } from 'react-router-dom';
import './ReviewContent.css';
import { allMovies } from './movieData';

function ReviewContent() {
  const { movieTitle } = useParams();
  const movieShow = allMovies.find((movie) => movie.movie === movieTitle);

  if (!movieShow) {
    return <p style={{ color: 'white' }}>Movie not found</p>;
  }

  return (
    <div className="main background">
      <div className="m-3 row mx-0 contain">
        <div className="image mt-2 p-2 col-12 col-md-4">
          <img src={movieShow.imageUrl} height="200" width="300" className="img-thumbnail" alt={`${movieShow.movie} poster`} />
          <div className="mt-2 p-2 text-white">
            <br /><br /><br />
            <strong>Director:</strong> {movieShow.director}<br />
            <strong>Producer:</strong> {movieShow.producer}<br />
            <strong>Starring:</strong> {movieShow.starring}<br /><br /><br />
            <strong>Rating:</strong> 3 / 5
          </div>
        </div>

        <div className="col-12 col-md-8 mt-2 p-2 text-white">
          <p className="top-content pb-3">
            <strong style={{ fontSize: 'larger' }}>{movieShow.movie}</strong><br />
            Directed by {movieShow.director}<br />
            Review: Swarnendu Saha
          </p>
          <div style={{ fontFamily: 'Cabin, sans-serif' }}>
            <strong>Good points:</strong>
            <ol><li>{movieShow.good1}</li><li>{movieShow.good2}</li><li>{movieShow.good3}</li></ol>
            <strong>Bad points:</strong>
            <ol><li>{movieShow.bad1}</li><li>{movieShow.bad2}</li><li>{movieShow.bad3}</li></ol>
            <strong>Plot:</strong> {movieShow.plot}<br /><br />
            <strong>Performance:</strong> {movieShow.performance}<br /><br />
            <strong>Direction:</strong> {movieShow.direction}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewContent;
